/* istanbul ignore file */
import React, { forwardRef, useContext } from 'react';
import _ from 'underscore';
import { AlertRegular } from '@fluentui/react-icons';
import { NavItem } from '@bingads-webui-fluent-component/global-menu-container';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  makeStyles, shorthands, tokens, mergeClasses,
} from '@fluentui/react-components';
import $ from 'jquery';
import type { II18n } from './types';

const useStyles = makeStyles({
  badge: {
    width: '8px',
    height: '8px',
    backgroundColor: tokens.colorPaletteRedForeground1,
    ...shorthands.borderRadius('100%'),
    position: 'absolute',
    top: '0px',
    right: '0px',
  },
  container: {
    position: 'relative',
  },
});

function AlertBadge() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={mergeClasses(classes.badge, 'notification-badge')} />
      <AlertRegular />
    </div>
  );
}

export const NotificationItem = forwardRef<HTMLDivElement, any>((props, ref) => {
  const i18n: II18n = useContext(I18nContext);

  const toggleNotification = () => {
    _.defer(() => {
      $('#unified-notification-queue-trigger-btn-id').click();
    });
  };

  return (
    <NavItem
      {...props}
      itemKey="Notifications"
      icon={props.isActive ? AlertBadge : AlertRegular}
      text={i18n.getString(_TL_('Notifications'))}
      onClick={() => toggleNotification()}
      ref={ref}
    />
  );
});
